import {
  Box,
  TextField,
  IconButton
} from '@mui/material';
import { Clear as ClearIcon } from '@mui/icons-material';
import { useTheme } from '@mui/material/styles';

const TranslationInput = ({ 
  value, 
  onChange, 
  onClear, 
  placeholder = "Enter text to translate..." 
}) => {
  const theme = useTheme();

  return (
    <Box sx={{ position: 'relative', mb: 3 }}>
      <TextField
        fullWidth
        multiline
        rows={4}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        variant="outlined"
        sx={{
          bgcolor: theme.palette.background.paper,
          borderRadius: 2,
          '& .MuiOutlinedInput-root': {
            borderRadius: 2,
            transition: 'all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1)',
            '& fieldset': {
              borderColor: theme.palette.outlineVariant,
              transition: 'all 0.3s ease',
            },
            '&:hover fieldset': {
              borderColor: theme.palette.primary.main,
            },
            '&.Mui-focused': {
              boxShadow: theme.palette.mode === 'dark'
                ? '0 0 0 4px rgba(181, 235, 185, 0.25)'
                : '0 0 0 4px rgba(0, 65, 73, 0.12)',
            },
            '&.Mui-focused fieldset': {
              borderColor: theme.palette.primary.main,
              borderWidth: '1px',
            }
          }
        }}
      />
      {value && (
        <IconButton 
          sx={{ 
            position: 'absolute', 
            right: 8, 
            top: 8, 
            color: theme.palette.text.secondary 
          }}
          onClick={onClear}
        >
          <ClearIcon />
        </IconButton>
      )}
    </Box>
  );
};

export default TranslationInput;